"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapOptions = void 0;
var LayerGroupCollections_1 = require("../layers/groups/LayerGroupCollections");
/**
 * Map options
 * */
var MapOptions = /** @class */ (function () {
    function MapOptions() {
        /**
        * The max zoom when zooming to the bounds of a feature
        * */
        this.maxZoomToBounds = 15;
        /**
        * ZoomToNearestBounds, if true then sometimes features are off the map, if false sometimes the map comes far out and there is a lot of space around the feature(s)
        * */
        this.zoomToNearestBounds = true;
        /**
        * The display projection the map
        * [optional] - defaults to EPSG:3857
        * */
        this.displayProjection = "EPSG:3857";
        this.layerGroupCollection = new LayerGroupCollections_1.LayerGroupCollections([]);
    }
    return MapOptions;
}());
exports.MapOptions = MapOptions;
//# sourceMappingURL=MapOptions.js.map